import axios from 'axios';
import { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { Modal, Spinner } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { FaRegCircleCheck, FaWhatsapp } from 'react-icons/fa6';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { SlArrowLeft } from 'react-icons/sl';
import { BASE_URL } from '../../../../insightConfig/insightConfig';
import '../../../../jsx/Dashborad/dashboard.css';
import CivilButton from '../../../ReusableComponent/CIVIL/CivilButton/CivilButton';
import NeetAllSubjectsPaymentModal from './NeetAllSubjectsPaymentModal';
import Select from 'react-select';
import neetinnerimage from '../../../../Image/neetbykanwalraj.png';


function NeetAllSubjectsHome() {
    const navigate = useNavigate();
    const alert = useAlert();
    const location = useLocation();

    const [open, setOpen] = useState(false);
    const [openPaymentProccessingModal, setPaymentProccessingModal] = useState(false);
    const email = localStorage.getItem("authtoken");
    const [subjects, setSubjects] = useState([]);
    const [subjectSpecificData, setSubjectSpecificData] = useState({});
    const [checkedSubjects, setCheckedSubjects] = useState([]);
    const [openPaymentSuccessModal, setPaymentSuccessModal] = useState(false);
    const [transactionId, setTransactionId] = useState('');
    const [selectedClass, setSelectedClass] = useState({ value: 'Class-11', label: 'Class-11' });
    const [selectedSidebarSubject, setSelectedSidebarSubject] = useState(null);
    const [selectedSidebarTest, setSelectedSidebarTest] = useState(null);
    const [tests, setTests] = useState([]);
    const enrolled = transactionId.length > 0;
    const orders = checkedSubjects?.filter(data => data.checked && data.Price);

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                // Fetch NEET subjects
                const response1 = await axios.get(BASE_URL + `/neet/user/subjects`);
                const subjectsData = response1.data.data || [];

                // Fetch test plans
                const response2 = await axios.get(BASE_URL + `/neet/user/test-plans`);
                const testPlans = response2.data.data || [];

                // Attach test plans to each subject
                const subjectsWithPlans = subjectsData.map(subject => ({
                    ...subject,
                    checked: false,
                    TestCount: 0,
                    Price: 0,
                    Discount: 0,
                    testPlans: testPlans,
                }));
                setSubjects(subjectsWithPlans);
            } catch (error) {
                console.log(error);
            }
        }
        fetchInitialData();
    }, []);

    useEffect(() => {
        const fetchSubjectMetadata = async () => {
            if (selectedSidebarSubject?.value?.Sn) {
                try {
                    const response = await axios.get(BASE_URL + `/neet/user/subject-specific-data/${selectedSidebarSubject.value.Sn}`);
                    const data = response?.data?.data?.[0];
                    if (data) {
                        setSubjectSpecificData(data);
                    } else {
                        setSubjectSpecificData({});
                    }
                } catch (error) {
                    console.error("Error fetching subject metadata:", error);
                    setSubjectSpecificData({});
                }
            } else {
                // Default metadata for All Subjects if no specific subject is selected in sidebar
                setSubjectSpecificData({
                    Thumbnail: null,
                    Description: "Enhance your NEET preparation with our comprehensive test series covering all core subjects."
                });
            }
        }
        fetchSubjectMetadata();
    }, [selectedSidebarSubject]);

    useEffect(() => {
        setCheckedSubjects(subjects.filter(data => data.checked && data.Price));
    }, [subjects]);

    const price = (checkedSubjects || [])
        .filter(data => typeof data.Price === 'number' && typeof data.Discount === 'number')
        .reduce((acc, curr) => acc + curr.Price, 0);

    const totalPayable = (checkedSubjects || [])
        .filter(data => typeof data.Price === 'number' && typeof data.Discount === 'number')
        .reduce((acc, curr) => acc + (curr.Price - (curr.Price * curr.Discount / 100)), 0);

    const handleEnroll = () => {
        if (checkedSubjects?.filter(data => data.checked && data.Price).length < 1) {
            alert.show("Please select at least one subject with valid test plan");
            return;
        }
        if (email) {
            setOpen(true);
        } else {
            navigate('/login');
        }
    }

    const handleSelectSubject = (subject, forceChecked = null) => {
        let copy = [...subjects];
        let selectedSubject = copy.find((data) => data.Sn == subject.Sn);
        if (selectedSubject) {
            selectedSubject.checked = forceChecked !== null ? forceChecked : !selectedSubject.checked;
            if (!selectedSubject.checked) {
                selectedSubject.TestCount = 0;
                selectedSubject.Price = 0;
            }
            setSubjects(copy);
        }
    };

    const handlePlanSelect = (subjectId, plan) => {
        let copy = [...subjects];
        let selectedSubject = copy.find((data) => data.Sn === subjectId);

        if (!selectedSubject || !selectedSubject.checked) return;

        selectedSubject.TestCount = plan?.TestCount || 0;
        selectedSubject.Price = plan?.Price || 0;
        selectedSubject.Discount = plan?.Discount || 0;
        selectedSubject.Section = plan?.Section || '';

        setSubjects(copy);
    };

    return (
        <>
            <Helmet>
                <title>{"NEET | All Subjects"}</title>
            </Helmet>
            {/* NEET All Subjects Page Start */}
            <div className='Dashboard-background'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-lg-3 col-md-12 col-sm-12 dashboardmain-left p-3'>
                            <div className='dashboardleft-background'>
                                <div className='dash1'>
                                    <div className="premium-img-wrapper">
                                        <img src={subjectSpecificData?.Thumbnail || neetinnerimage} className='premium-img-bg' alt="Background" />
                                        <img src={subjectSpecificData?.Thumbnail || neetinnerimage} className='premium-img-overlay' alt={subjectSpecificData?.Subject || "NEET Subjects"} />
                                    </div>
                                </div>

                                <div className='dash2'>
                                    <div className="d-grid gap-2">
                                        <Link to={'/StudentDashboard'} state={{ prePath: location.pathname, moduleName: 'neet' }} className="btn d-flex align-items-center justify-content-center btn-orange fw-bold py-3" type="button" style={{ letterSpacing: '0.5px', fontSize: '1.05rem' }}>Dashboard</Link>
                                        
                                        

                                        <div className="border border-2 rounded border-gray">
                                            <label htmlFor="select_subj" className='btn_custom_class btn d-flex align-items-center justify-content-center fw-bold text-white text-uppercase' style={{ cursor: 'default' }}>Choose your Subject</label>
                                            <Select
                                                id='select_subj'
                                                value={selectedSidebarSubject}
                                                placeholder="Select Subject"
                                                onChange={(selectedOption) => {
                                                    setSelectedSidebarSubject(selectedOption);
                                                    setSelectedSidebarTest(null);
                                                    // Automatically check the subject in the table
                                                    handleSelectSubject(selectedOption.value, true); 
                                                }}
                                                options={subjects?.map((item) => ({ value: item, label: item.Subject }))}
                                                styles={{
                                                    control: (provided) => ({ ...provided, textAlign: 'center', cursor: 'pointer', borderColor: '#17a2b8' }),
                                                    option: (provided) => ({ ...provided, cursor: 'pointer', textAlign: 'center' }),
                                                    singleValue: (provided) => ({ ...provided, textAlign: 'center' })
                                                }}
                                            />
                                        </div>


<div className="border border-2 rounded border-gray">
                                            <label htmlFor="select_class" className='btn_custom_class btn d-flex align-items-center justify-content-center fw-bold text-white text-uppercase' style={{ cursor: 'default' }}>Choose your Class</label>
                                            <Select
                                                id='select_class'
                                                value={selectedClass}
                                                onChange={(selectedOption) => {
                                                    setSelectedClass(selectedOption);
                                                    setSelectedSidebarTest(null);
                                                }}
                                                options={[
                                                    { value: 'Class-11', label: 'Class-11' },
                                                    { value: 'Class-12', label: 'Class-12' }
                                                ]}
                                                styles={{
                                                    control: (provided) => ({ ...provided, textAlign: 'center', cursor: 'pointer', borderColor: '#17a2b8' }),
                                                    option: (provided) => ({ ...provided, cursor: 'pointer', textAlign: 'center' }),
                                                    singleValue: (provided) => ({ ...provided, textAlign: 'center' })
                                                }}
                                            />
                                        </div>

                                        
                                        <div className="border border-2 rounded border-gray">
                                            <label htmlFor="select_test" className='btn_custom_class btn d-flex align-items-center justify-content-center fw-bold text-white text-uppercase' style={{ cursor: 'default' }}>Select Number of Tests</label>
                                            <Select
                                                id='select_test'
                                                value={selectedSidebarTest}
                                                placeholder="Select Tests"
                                                onChange={(selectedOption) => {
                                                    setSelectedSidebarTest(selectedOption);
                                                    if (selectedSidebarSubject) {
                                                        handlePlanSelect(selectedSidebarSubject.value.Sn, selectedOption.value);
                                                    }
                                                    // Update the list of tests to display
                                                    if (selectedOption.value?.TestCount) {
                                                        setTests(new Array(selectedOption.value.TestCount).fill(1));
                                                    } else {
                                                        setTests([]);
                                                    }
                                                }}
                                                options={subjects?.find(s => s.Sn === selectedSidebarSubject?.value?.Sn)?.testPlans
                                                    ?.filter(plan => plan.Section === selectedClass.value && plan.SubjectID == selectedSidebarSubject?.value?.Sn)
                                                    ?.map((item) => ({ value: item, label: item.TestCount + " Tests" })) || []}
                                                styles={{
                                                    control: (provided) => ({ ...provided, textAlign: 'center', cursor: 'pointer', borderColor: '#17a2b8' }),
                                                    option: (provided) => ({ ...provided, cursor: 'pointer', textAlign: 'center' }),
                                                    singleValue: (provided) => ({ ...provided, textAlign: 'center' })
                                                }}
                                            />
                                        </div>
                                        <button
                                            onClick={handleEnroll}
                                            className="btn btn-orange py-2 px-3 d-flex flex-column align-items-center justify-content-center"
                                            type="button"
                                        >
                                            {checkedSubjects?.filter(data => data.checked && data.Price).length > 0 ? (
                                                <>
                                                    <div className='d-flex align-items-center justify-content-center flex-wrap mb-1' style={{ gap: "10px", opacity: 0.9 }}>
                                                        <span className='text-decoration-line-through text-uppercase' style={{ fontSize: '1rem' }}>
                                                            FEE ₹{price || 500}
                                                        </span>
                                                        <span className='fw-bold text-uppercase' style={{ fontSize: '1rem', background: 'rgba(255,255,255,0.2)', padding: '2px 8px', borderRadius: '4px' }}>
                                                            DISCOUNT ₹{(price - totalPayable) > 0 ? Math.ceil(price - totalPayable).toLocaleString("en-IN") : 100}
                                                        </span>
                                                    </div>
                                                    <div className='fw-bold text-uppercase' style={{ fontSize: '1.1rem', letterSpacing: '1px' }}>
                                                        ₹{totalPayable > 0 ? totalPayable.toLocaleString("en-IN") : 400} - {totalPayable < 1 ? 'ENROLL FOR FREE' : 'ENROLL NOW'}
                                                    </div>
                                                </>
                                            ) : (
                                                <div className='fw-bold text-uppercase' style={{ fontSize: '1.2rem', letterSpacing: '1px', padding: '10px 0' }}>
                                                    ENROLL NOW
                                                </div>
                                            )}
                                        </button>

                                        <Link to="https://api.whatsapp.com/send?phone=919818333201" target='_blank' className="btn d-flex align-items-center justify-content-center btn-whatsapp fw-bold py-3" type="button" style={{ letterSpacing: '0.5px', fontSize: '1.05rem' }}><FaWhatsapp className='me-1 fs-4' /> WHATSAPP 9818333201</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-9 col-md-12 col-sm-12'>
                            <div className="d-flex justify-content-between align-items-center p-2 py-1 mb-3 bg-light border rounded shadow-sm">
                                <button
                                    className="btn btn-sm"
                                    style={{
                                        backgroundColor: '#17a2b8',
                                        color: 'white',
                                        fontWeight: 'bold',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '5px',
                                        padding: '4px 12px',
                                        border: 'none',
                                        borderRadius: '4px',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => navigate(-1)}
                                >
                                    <SlArrowLeft /> Back
                                </button>
                                <h2 className="mb-0 fs-5" style={{ color: 'rgb(183, 6, 6)', fontWeight: 600, letterSpacing: '0.5px', textShadow: '0 1px 1px rgba(0,0,0,0.1)', lineHeight: '1.2' }}>NEET All Subjects Tests</h2>
                                <Link to={'/StudentDashboard'} state={{ prePath: location.pathname, moduleName: 'neet' }} style={{ textDecoration: 'none', color: '#17a2b8', fontWeight: 'bold' }}>Dashboard</Link>
                            </div>
                            <CivilButton 
                                overView={subjectSpecificData?.Description} 
                                componentName="NEET All Subjects" 
                                NEET_Tests={tests} 
                                Neet_Subject={selectedSidebarSubject?.label || "Please select subject"}
                                enrolled={enrolled}
                                onTakeTest={handleEnroll} 
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={open} centered className="animate__animated animate__fadeIn mobileyoutube">
                <NeetAllSubjectsPaymentModal setOpen={setOpen} Amount={totalPayable} orders={orders} setPaymentProccessingModal={setPaymentProccessingModal} setPaymentSuccessModal={setPaymentSuccessModal} setTransactionId={setTransactionId} />
            </Modal>
            <Modal show={openPaymentProccessingModal} top backdrop="static" dialogClassName="custom-modal-width">
                <div className="modal-content" style={{ backgroundColor: "#f0f8ff", padding: "2rem", borderRadius: "10px" }}>
                    <div className="modal-body" style={{ padding: "2rem" }}>
                        <div className="mb-3 d-block text-center">
                            <Spinner
                                animation="border"
                                className="mt-5 mb-3"
                                size="xl"
                                style={{ width: "200px", height: "200px", color: "#ff2f00" }}
                            />
                            <h5
                                className="modal-title mb-5"
                                id="exampleModalLabel"
                                style={{ color: "#17a2b8", fontFamily: "Arial, sans-serif" }}
                            >
                                Saving Order Details. This may take a moment...
                            </h5>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal show={openPaymentSuccessModal} top backdrop="static" dialogClassName="" size="lg" centered>
                <div className="" style={{ backgroundColor: "#f0f8ff", padding: "2rem", borderRadius: "10px" }}>
                    <div className='p-5 py-3 d-flex justify-content-center align-items-center' >
                        <div className='text-black text-center'>
                            <FaRegCircleCheck className='text-orange' style={{ fontSize: "15vmax" }} />
                            <h1 className='py-2 fw-bold text-success'>Payment Successful</h1>
                            <h4 className='text-info'>Your order has been placed Successfully</h4>
                            <h6> <span style={{ fontWeight: "700" }}>Program Name</span> : NEET All Subjects : ({orders?.map((obj, index) => {
                                if (index == (orders?.length || 0) - 1) {
                                    return <span key={index}>{obj?.Subject}</span>
                                } else {
                                    return <span key={index}>{obj?.Subject + ", "}</span>
                                }
                            })})</h6>
                            <h6><span style={{ fontWeight: "700" }}>Payment ID</span> : {transactionId}</h6>

                            <div className='p-3 d-flex justify-content-around flex-column w-75 mx-auto '>
                                <Link to={`/StudentDashboard`} state={{ prePath: location.pathname, moduleName: 'neet' }} style={{ textDecoration: "none" }} className='bg-orange text-white py-2 rounded-pill fs-6 px-4' >
                                    Go to My Dashboard
                                </Link>
                                <Link onClick={() => setPaymentSuccessModal(false)} style={{ textDecoration: "none" }} className='bg-orange text-white py-2 rounded-pill fs-6 px-4 my-2' >
                                    Close
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            {/* NEET All Subjects Page End */}
        </>
    )
}

export default NeetAllSubjectsHome;
